import { render, staticRenderFns } from "./finance-products.vue?vue&type=template&id=5732a3de&"
import script from "./finance-products.vue?vue&type=script&lang=js&"
export * from "./finance-products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports